import React from 'react';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import { staticURL } from 'core/url';

import { media } from 'legacyComponents/styled/styleUtils';
import { ButtonGroup } from 'legacyComponents/styles';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import { PostCard } from 'legacyComponents/cards/styles';
import { Heading, Paragraph } from 'components';

export const brandIcons = {
  Visa: 'visa.svg',
  MasterCard: 'mastercard.svg',
  'American Express': 'amex.svg',
  UnionPay: 'unionpay.svg',
  'Diners Club': 'diners.svg',
  Discover: 'discover.svg',
  JCB: 'jcb.svg',
  Unknown: 'default.svg',
};

export const CreditCard = withNamespaces()(
  observer(({ cardObject, cardNo, cardColumns, children }) => {
    const noMargin = (cardNo + 1) % cardColumns === 0;
    if (cardObject === null) {
      return <CardIndicator noMargin={noMargin} type='issue' />;
    }
    const { brand, name, lastDigits, expMonth, expYear } = cardObject;

    return (
      <Card>
        <div>
          <CardLogo
            src={staticURL(`/assets/creditCards/flat/${brandIcons[brand]}`)}
          />
          <TextWrapper>
            <Heading level={5}>{name}</Heading>
            <Paragraph>
              <strong>**** **** **** {lastDigits}</strong> &mdash; Exp:{' '}
              <strong>
                {expMonth}/{expYear}
              </strong>
            </Paragraph>
          </TextWrapper>
        </div>
        <ButtonGroup>{children}</ButtonGroup>
      </Card>
    );
  }),
);

const Card = styled(PostCard)`
  padding: 16px;
  display: flex;
  justify-content: space-between;
`;

export const CardLogo = styled.img`
  height: 30px;
  width: auto;
  margin-right: 16px;
  display: inline-block;
  vertical-align: top;
  opacity: ${props => (props.mono ? '0.4' : '1')};
  ${media.xs`
    height: ${props => (props.mono ? '20px' : '30px')};
  `};
`;

const TextWrapper = styled.div`
  display: inline-block;
  vertical-align: top;
  > h5 {
    margin: 0 0 8px;
  }
  > p {
    font-size: 0.9em;
  }
`;

export const DeleteButton = styled.button`
  background-color: transparent;
  border: none;
  text-decoration: underline;
  font-size: 0.8em;
  cursor: pointer;
  color: ${props => props.theme.color.wfGrey500};
  &:hover {
    color: ${props => props.theme.color.wfOrange};
  }
`;

CreditCard.propTypes = {
  cardObject: PropTypes.object,
  cardNo: PropTypes.number,
};
